import React from 'react';
import { API_BASE_URL } from '../config/api';

const SiteDisplayCard = ({ site, onSiteClick, onDirectBooking }) => {
  const getPlaceholderImage = (siteName) => {
    const name = siteName.toLowerCase();
    if (name.includes('beach')) return 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop';
    if (name.includes('temple')) return 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=300&fit=crop';
    if (name.includes('jagannath')) return 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?w=400&h=300&fit=crop';
    if (name.includes('konark')) return 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop';
    if (name.includes('lingaraj')) return 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=400&h=300&fit=crop';
    if (name.includes('lake')) return 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop';
    if (name.includes('park')) return 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&h=300&fit=crop';
    if (name.includes('fort')) return 'https://images.unsplash.com/photo-1539650116574-75c0c6d73f6e?w=400&h=300&fit=crop';
    if (name.includes('cave')) return 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=400&h=300&fit=crop';
    if (name.includes('dam')) return 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400&h=300&fit=crop';
    return 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=300&fit=crop';
  };

  const getCategoryIcon = (category) => {
    const categoryIcons = {
      'temple': '🛕',
      'beach': '🏖️',
      'park': '🌳',
      'historical': '🏰',
      'mountain': '⛰️',
      'waterfall': '💧',
      'lake': '🏞️',
      'cave': '🕳️',
      'dam': '🌊',
      'wildlife': '🦁',
      'museum': '🏛️',
      'other': '📍'
    };
    return categoryIcons[category] || '🏛️';
  };

  const getCategoryLabel = (category) => {
    const categoryLabels = {
      'temple': 'Temple',
      'beach': 'Beach',
      'park': 'Park',
      'historical': 'Historical',
      'mountain': 'Mountain',
      'waterfall': 'Waterfall',
      'lake': 'Lake',
      'cave': 'Cave',
      'dam': 'Dam',
      'wildlife': 'Wildlife',
      'museum': 'Museum',
      'other': 'Other'
    };
    return categoryLabels[category] || 'Other';
  };

  const getSiteIcon = (siteName, category) => {
    if (category) return getCategoryIcon(category);
    if (siteName.toLowerCase().includes('beach')) return '🏖️';
    if (siteName.toLowerCase().includes('temple')) return '🛕';
    if (siteName.toLowerCase().includes('lake')) return '🏞️';
    if (siteName.toLowerCase().includes('park')) return '🌳';
    if (siteName.toLowerCase().includes('fort')) return '🏰';
    if (siteName.toLowerCase().includes('cave')) return '🕳️';
    if (siteName.toLowerCase().includes('dam')) return '🌊';
    return '🏛️';
  };

  const handleSiteClick = () => {
    // Check if site is disabled
    if (site.isActive === false) {
      onSiteClick(site);
      return;
    }
    
    if (site.tickets.length === 1 && onDirectBooking) {
      onDirectBooking(site.tickets[0]);
    } else {
      onSiteClick(site);
    }
  };

  return (
    <div 
      onClick={handleSiteClick}
      style={{
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(20px)',
        borderRadius: window.innerWidth <= 768 ? '16px' : '24px',
        overflow: 'hidden',
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        cursor: 'pointer',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        border: '1px solid rgba(255,255,255,0.2)',
        position: 'relative'
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
        e.currentTarget.style.boxShadow = '0 20px 60px rgba(0,0,0,0.2)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'translateY(0) scale(1)';
        e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.12)';
      }}
    >
      {/* Site Image */}
      <div style={{ position: 'relative', height: '200px', overflow: 'hidden' }}>
        <img 
          src={site.images && site.images.length > 0 ? `https://tiketjini.com${site.images[0].path}` : getPlaceholderImage(site.name)}
          alt={site.name}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          onError={(e) => {
            console.log('Image failed to load:', e.target.src);
            e.target.src = getPlaceholderImage(site.name);
          }}
        />
        
        {/* Gradient Overlay */}
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '50%',
          background: 'linear-gradient(transparent, rgba(0,0,0,0.7))'
        }} />
        
        {/* Site Icon */}
        <div style={{
          position: 'absolute',
          top: '16px',
          left: '16px',
          background: 'rgba(255,255,255,0.9)',
          backdropFilter: 'blur(10px)',
          padding: '8px',
          borderRadius: '50%',
          fontSize: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
        }}>
          {getSiteIcon(site.name, site.category)}
        </div>
        
        {/* Category Badge */}
        {site.category && (
          <div style={{
            position: 'absolute',
            bottom: '16px',
            right: '16px',
            background: 'rgba(0,0,0,0.7)',
            color: 'white',
            padding: '4px 8px',
            borderRadius: '12px',
            fontSize: '12px',
            fontWeight: '600'
          }}>
            {getCategoryLabel(site.category)}
          </div>
        )}
        
        {/* Image Count Badge */}
        {site.images && site.images.length > 1 && (
          <div style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'rgba(0,0,0,0.7)',
            color: 'white',
            padding: '4px 8px',
            borderRadius: '12px',
            fontSize: '12px',
            fontWeight: '600'
          }}>
            +{site.images.length - 1} more
          </div>
        )}
        
        {/* Site Name Overlay */}
        <div style={{
          position: 'absolute',
          bottom: '16px',
          left: '16px',
          right: '16px'
        }}>
          <h3 style={{
            margin: 0,
            color: 'white',
            fontSize: window.innerWidth <= 768 ? '1.1rem' : '1.25rem',
            fontWeight: '700',
            textShadow: '0 2px 4px rgba(0,0,0,0.5)',
            lineHeight: '1.3'
          }}>
            {site.name}
          </h3>
        </div>
      </div>
      
      {/* Content */}
      <div style={{ padding: window.innerWidth <= 768 ? '16px' : '20px' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginBottom: '12px'
        }}>
          <span style={{ fontSize: '14px' }}>📍</span>
          <span style={{
            color: '#718096',
            fontSize: '14px',
            fontWeight: '500'
          }}>
            {site.city}
          </span>
        </div>
        
        <p style={{
          color: '#4a5568',
          fontSize: '14px',
          margin: '0 0 16px',
          lineHeight: '1.5',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden'
        }}>
          {site.description}
        </p>
        
        {/* Ticket Count / Status */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '16px'
        }}>
          {site.isActive === false ? (
            <div style={{
              background: 'rgba(156, 163, 175, 0.1)',
              color: '#6b7280',
              padding: '6px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}>
              🔒 Site temporarily disabled
            </div>
          ) : (
            <div style={{
              background: 'rgba(102, 126, 234, 0.1)',
              color: '#667eea',
              padding: '6px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}>
              🎫 {site.tickets.length} ticket{site.tickets.length !== 1 ? 's' : ''} available
            </div>
          )}
        </div>
        
        {/* View Tickets Button */}
        <button 
          style={{
            width: '100%',
            background: site.isActive === false 
              ? 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)' 
              : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            padding: window.innerWidth <= 768 ? '12px' : '14px',
            borderRadius: window.innerWidth <= 768 ? '12px' : '16px',
            fontSize: window.innerWidth <= 768 ? '14px' : '16px',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: site.isActive === false 
              ? '0 4px 15px rgba(156, 163, 175, 0.4)' 
              : '0 4px 15px rgba(102, 126, 234, 0.4)',
            opacity: site.isActive === false ? 0.8 : 1
          }}
          onMouseOver={(e) => {
            if (site.isActive !== false) {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.6)';
            }
          }}
          onMouseOut={(e) => {
            if (site.isActive !== false) {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
            }
          }}
        >
          {site.isActive === false 
            ? 'Coming Soon 🔒' 
            : (site.tickets.length === 1 ? 'Book Now →' : 'View Tickets →')
          }
        </button>
      </div>
    </div>
  );
};

export default SiteDisplayCard;